export const invalidName = (value: string) =>
  !value || value.trim().split(' ').length <= 1;
